import React from 'react';
import { Award, Clock, Users, Shield, DollarSign, Zap } from 'lucide-react';
import CounterAnimation from './CounterAnimation';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: Award,
      title: 'High Approval Success Rate',
      description: 'Our experienced professionals maintain one of the strongest approval performance levels in the industry, ensuring reliable trademark acceptance outcomes'
    },
    {
      icon: Clock,
      title: 'Quick Turnaround Processing',
      description: 'We deliver fast application preparation and filing services, typically completed within a 24–48 hour timeframe for quicker submission'
    },
    {
      icon: Users,
      title: 'Thousands of Trusted Clients',
      description: 'Businesses of all sizes, from emerging startups to established global enterprises, rely on our trusted trademark services'
    },
    {
      icon: Shield,
      title: 'Refund Assurance Policy',
      description: 'If we determine your trademark is already registered or unavailable, we ensure a complete refund for your peace of mind'
    },
    {
      icon: DollarSign,
      title: 'Clear and Honest Pricing',
      description: 'We believe in full transparency with no hidden charges—only upfront quoted pricing plus standard USPTO fees'
    },
    {
      icon: Zap,
      title: 'AI-Driven Search Technology',
      description: 'Our intelligent search system scans millions of trademark records within seconds to detect possible conflicts before filing'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Why Choose Global Trademark Filer?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We merge advanced technology with specialized legal expertise to secure and safeguard your brand identity
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-14 h-14 bg-[#168356] rounded-lg flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                <benefit.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {benefit.statNum ? (
                  <>
                    <CounterAnimation 
                      end={benefit.statNum} 
                      suffix={benefit.statSuffix || ''} 
                    />{' '}
                    {benefit.title}
                  </>
                ) : (
                  benefit.title
                )}
              </h3>
              <p className="text-gray-600">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default WhyChooseUs;